import { render } from "./AcceptCancelButtons.vue?vue&type=template&id=d60a6634&scoped=true"
import script from "./AcceptCancelButtons.vue?vue&type=script&lang=js"
export * from "./AcceptCancelButtons.vue?vue&type=script&lang=js"

import "./AcceptCancelButtons.vue?vue&type=style&index=0&id=d60a6634&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d60a6634"

export default script